import { useForm } from "antd/lib/form/Form";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../shared/types/common";
import { Drawer } from "antd";
import GenericFormComponent from "../../../shared/components/generic-form/generic-form.component";
import { useEffect } from "react";
import { showNotification } from "../../../shared/utils/utils";
import {
  addForex,
  updateForexDetails,
} from "../../../core/store/reducers/master.slice";
import dayjs from "dayjs";

interface Props {
  onClose: () => void;
  visible: boolean;
  selectedEntity?: any;
  onSubmit?: () => void;
  currencies: any;
}

const CreateEditForexComponent = ({
  onClose,
  visible,
  selectedEntity = null,
  currencies,
  onSubmit = () => {
    return;
  },
}: Props) => {
  const dispatch = useDispatch();
  const [form] = useForm();
  const { screenType } = useSelector((state: RootState) => state.settings);

  const onFinish = (values: any) => {
    const payload = {
      currencyId: values?.currencyId,
      inrMultiplier: values?.inrMultiplier,
      startDate: values?.startDate
        ? dayjs(values.startDate).startOf("month").format("YYYY-MM-DD")
        : null,
      endDate: values?.endDate
        ? dayjs(values.endDate).endOf("month").format("YYYY-MM-DD")
        : null,
    };
    if (selectedEntity) {
      dispatch(
        updateForexDetails({ id: selectedEntity?.id, body: payload })
      ).then((val: any) => {
        if (val?.payload?.data?.success) {
          showNotification("Forex Details Updated Successfully", "success");
          onSubmit();
        }else if(val?.payload?.data?.message?.includes("already exists")){
          showNotification('Forex overlaps with an existing record.', "error");
        }
      });
    } else {
      dispatch(addForex(payload)).then((val: any) => {
        if (val?.payload?.data?.success) {
          showNotification("Forex Added Successfully", "success");
          onSubmit();
        }else if(val?.payload?.data?.message?.includes("already exists")){
          showNotification('Forex overlaps with an existing record.', "error");
        }
      });
    }
  };

  const onFinishFailed = (_errorInfo: any) => {
    return;
  };

  const onValuesChange = (value: any, _allValues: any) => {};

  var colSpan = screenType.isPortrait ? 24 : 12;
  const formProps = {
    form: form,
    name: "creat-edit-forex",
    heading: selectedEntity ? "Edit Forex Details" : "Add New Forex",
    initialValues: {
      status: "ACTIVE",
      inrMultiplier: 0,
    },
    formElements: [
      {
        name: "currencyId",
        label: "Currency",
        placeholder: "Currency",
        type: "Select",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        options: currencies?.map((Currency: any) => ({
          value: Currency?.id,
          label: Currency?.name,
        })),
        rules: [{ required: true, message: "Please enter Currency" }],
      },
      {
        name: "inrMultiplier",
        colSpan: 12,
        label: "INR Multiplier",
        placeholder: "Enter INR Multiplier",
        type: "InputNumber",
        isAmount: true,
        allowClear: true,
        min: 0,
        rules: [{ required: true, message: "Please enter INR Multiplier" }],
      },
      {
        name: "startDate",
        label: "Start Month",
        placeholder: "Start Month",
        type: "MonthPicker",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        rules: [{ required: true, message: "Start Month Required" }],
      },
      {
        name: "endDate",
        label: "End Month",
        placeholder: "End Month",
        type: "MonthPicker",
        colSpan: colSpan,
        showSearch: true,
        allowClear: true,
        dependencies: ["startDate"],
        rules: [
          { required: true, message: "End Month Required" },
          ({ getFieldValue }: any) => ({
            validator(_: any, value: any) {
              const startDate = getFieldValue("startDate");

              if (!value || !startDate || !dayjs(value).isBefore(dayjs(startDate), "month")) {
                return Promise.resolve();
              }

              return Promise.reject(
                new Error("End Month cannot be earlier than Start Month")
              );
            },
          }),
        ],
        disabledDate: (current: any) => {
          const startDate = form.getFieldValue("startDate");
          if (!startDate) return false;
        
          // disable months before OR equal to selected startDate
          return current <= dayjs(startDate).endOf("month");
        },        
      },
    ],
    extraButtons: [
      {
        htmlType: "button",
        colSpan: 5,
        loading: false,
        submitButtonText: "Cancel",
        onClick: onClose,
      },
      {
        htmlType: "button",
        colSpan: 5,
        loading: false,
        submitButtonText: "Clear",
        type: "clearForm",
      },
      {
        htmlType: "submit",
        colSpan: 5,
        loading: false,
        submitButtonText: "Save",
        submitButtonType: "primary",
      },
    ],
    onFinish: onFinish,
    onFinishFailed: onFinishFailed,
    onValuesChange: onValuesChange,
  };

  useEffect(() => {
    if (selectedEntity) {
      form.setFieldsValue({
        currencyId: selectedEntity?.currencyId,
        inrMultiplier: selectedEntity?.inrMultiplier,
        startDate: dayjs(selectedEntity?.startDate),
        endDate: dayjs(selectedEntity?.endDate),
      });
    }
  }, [form, selectedEntity]);

  return (
    <>
      <Drawer
        maskClosable={false}
        title={<strong>{formProps.heading}</strong>}
        className="form-drawer"
        width={
          screenType.isPortrait
            ? "90%"
            : screenType.isLg || screenType.isXl
            ? 720
            : 500
        }
        onClose={onClose}
        open={visible}
      >
        <GenericFormComponent {...formProps} />
      </Drawer>
    </>
  );
};
export default CreateEditForexComponent;
